// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".font-size-26[data-v-7fae0a49]{font-size:26px}.fa-fix-size[data-v-7fae0a49]{font-size:13px;line-height:24px;text-align:center;width:30px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
